import React from 'react';
import { CheckIcon, XIcon, RocketIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { ACCELERATOR_ROWS, ACCELERATOR_INCLUDES } from './salesData';
export function AcceleratorSection() {
  return <section className="bg-ink py-16 text-cream sm:py-24" data-id="element-13" data-mp="3ey0g5ixrhf4p">
      <div className="mx-auto max-w-5xl px-5" data-id="element-14" data-mp="39yfkbhdw1mw7">
        <div className="text-center" data-id="element-15" data-mp="39wkxfxj23kph">
          <span className="inline-block rounded-full border border-white/20 bg-white/5 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-rose-soft" data-id="element-16" data-mp="3nxx9vyz0d46m">
            🚀 Acelerador opcional
          </span>
          <h2 className="mt-4 font-display text-3xl font-black leading-tight sm:text-4xl" data-id="element-17" data-mp="1ivpwf1hdyfk">
            ¿Qué agrega el Acelerador "Estética Ads Pro"?
          </h2>
        </div>

        {/* Comparison table */}
        <div className="mt-10 overflow-x-auto rounded-2xl border border-white/10" data-id="element-18" data-mp="ai95zqk41l99">
          <p className="px-4 py-2 text-center text-xs text-cream/50 sm:hidden" data-id="element-19" data-mp="6hyxo78uiir8">← Deslizá para ver la tabla completa →</p>
          <table className="w-full min-w-[560px] border-collapse text-left text-sm" data-id="element-20" data-mp="21ygup3teujqw">
            <thead data-id="element-21" data-mp="25y8w8wkdzpmr">
              <tr className="bg-white/5" data-id="element-22" data-mp="25zscin61m0oj">
                <th className="px-4 py-3 font-semibold text-cream/90" data-id="element-23" data-mp="260tz9owf8bm3">Situación en tu negocio</th>
                <th className="px-4 py-3 font-semibold text-rose-soft" data-id="element-24" data-mp="2b0gdo1nzjxwh">❌ Sin Acelerador</th>
                <th className="px-4 py-3 font-semibold text-emerald-300" data-id="element-25" data-mp="2fv3vxisebw2m">✅ Con Acelerador</th>
              </tr>
            </thead>
            <tbody data-id="element-26" data-mp="2oxd2jxkjn5aq">
              {ACCELERATOR_ROWS.map((row, i) => <tr key={i} className="border-t border-white/10" data-id="element-27" data-mp="2oviielh3jh7p" data-mpi={i}>
                  <td className="px-4 py-3 font-medium text-cream/90" data-id="element-28" data-mp="2tp4x0j6tlv65">{row.situation}</td>
                  <td className="px-4 py-3 text-cream/60" data-id="element-29" data-mp="2ymd51qy98ito">{row.without}</td>
                  <td className="px-4 py-3 font-semibold text-cream" data-id="element-30" data-mp="33nkb9lkr19y8">{row.with}</td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="mt-10 rounded-2xl border border-white/10 bg-white/5 p-6 sm:p-8" data-id="element-31" data-mp="2ixq6r24n6a49">
          <h3 className="flex items-center gap-2 font-display text-xl font-bold" data-id="element-32" data-mp="2ivdqctej87tb">
            <RocketIcon className="h-5 w-5 text-rose-soft" data-id="element-33" data-mp="2e0gj9s0tc8j2" /> El Acelerador incluye:
          </h3>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-34" data-mp="2soulc0qensyk">
            {ACCELERATOR_INCLUDES.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-35" data-mp="2nuqfjksvlqz2">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-emerald-300" data-id="element-36" data-mp="31mwqmsh697rn" />
                <span className="text-sm leading-relaxed text-cream/80" data-id="element-37" data-mp="2wo3dj15sris0">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}